import development from './development'
import staging from './staging'
import stagingMock from './stagingMock'
import test from './test'

const ENVIRONMENTS_BY_HOST = {
  localhost: development,
  '127.0.0.1': development, // Localhost alias
  '0.0.0.0': development, // If listening on all interfaces, not only localhost
  'ctt-clientes.redradix.com': staging,
}

const ENVIRONMENTS_BY_NAME = {
  development,
  staging,
  stagingMock,
  test,
}

const forcedEnvironmentName = process.env.REACT_APP_FORCED_ENV
const host = window.location.hostname

const ENVIRONMENT =
  ENVIRONMENTS_BY_NAME[forcedEnvironmentName] ??
  ENVIRONMENTS_BY_HOST[host] ??
  development

export default ENVIRONMENT
